// extracted by mini-css-extract-plugin
export var base = "_4t-0";
export var updateBanner = "_4t-1";